// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zcJh","clinicsSelect":"styles_clinicsSelect__3Nftt"};